// extracted by mini-css-extract-plugin
export var base = "_1c-0";
export var updateBanner = "_1c-1";